import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import { GetSuccessPayload } from "./translation.model";

const ACTION_PREFIX = "[Translation]";

/**
 * @deprecated - [fabric-deprecated]
 */
export namespace TranslationAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getTranslationGroups) instead
	 */
	export const get = createAction(`${ACTION_PREFIX} Get`, (groupNames: string[]) => ({
		payload: groupNames,
		groupNames,
	}));

	/**
	 * @deprecated - [fabric-deprecated]
	 */

	export const getSuccess = createAction(`${ACTION_PREFIX} Get Success`, (payload: GetSuccessPayload) => ({
		payload,
	}));

	/**
	 * @deprecated - [fabric-deprecated]
	 */

	export const getFail = createAction(`${ACTION_PREFIX} Get Fail`, (error: AppError) => ({ payload: error, error }));

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	export const setClientLoaded = createAction(`${ACTION_PREFIX} Set Client Loaded`);

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	export const init = createAction(`${ACTION_PREFIX} Init`, (language: string) => ({ payload: language, language }));
}
